import '../../datadog';
import '../../hotjar-init';

import { BitkitProvider } from '@bitrise/bitkit-v2';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { AlertProvider } from '@/hooks/useAlert';
import Status500ErrorPageContent from '@/pages/error/ErrorPage/Status500ErrorPageContent';
import { dataDogErrorHandler } from '@/utils/dataDogErrorHandler';
import { globalProps } from '@/utils/globalProps';
import { queryClient } from '@/utils/query';

import { GlobalPropsContext } from './GlobalPropsContext';

export const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <BitkitProvider>
      <ErrorBoundary FallbackComponent={Status500ErrorPageContent} onError={dataDogErrorHandler}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
          <AlertProvider>
            <GlobalPropsContext.Provider value={globalProps}>{children}</GlobalPropsContext.Provider>
          </AlertProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </BitkitProvider>
  );
};
